<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <Loading v-if="loading"/>
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="col-auto">
                <card shadow class="card-profile mt--400" no-body>
                   <div class="card-header text-center">
                    <div class="row">
                    <h3 class="col-10">
                        Attendance
                    </h3>
                     <!-- <a class="btn btn-warning col-2 float-right" href="/#/absent"><i class="ni ni-circle-08 nix3"></i> Absent Staff</a> -->
                    </div>

                   </div>

                   
                    <div class="p-4">
                        <div class="text-center">
                            <div class="row justify-content mt-2">
                                    <div class="col-3">
                                    <label>Select Date Range To Filter Report :</label>
                                    <base-input addon-left-icon="ni ni-calendar-grid-58">
                                        <flat-picker  slot-scope="{focus, blur}" 
                                                    @on-open="focus" 
                                                    @on-close="blur"                                                    
                                                    :config="{allowInput: true, mode: 'range'}"
                                                    class="form-control datepicker"
                                                    v-model="form.range">
                                        </flat-picker>
                                    </base-input>
                                    </div>
                                    <div class="col-1" >
                                        <br>
                                        <button @click="getReport" v-if ="!loading" class="btn btn-button bg-gradient-primary text-white mt-2"><i class="fa fa-refresh"></i> Refresh</button>
                                    </div>
                           
                                
                                
                            </div>

                            <div class="row justify-content-center mt-2">
                                 <div class="col-lg-12">
                                    <table class="table table-striped table-responsive" id="myTable">
                                    <thead>
                                        <tr>                                
                                            <th scope="col">Date</th>
                                            <th scope="col">Task</th>
                                            <th scope="col">Time</th>
                                            <th scope="col">Department</th>
                                            <th scope="col">Branch</th>
                                            <th scope="col">Recommended Time</th>
                                            <th scope="col">Location Scanned</th>
                                            <th scope="col">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(staff,index) in report" :key="index" >
                                            <td>{{ moment(staff.TrxDate).subtract(3,'hours').format("HH:mm MMM Do YY")}}</td>
                                            <td>{{ staff["StaffTask.TaskName"]}}</td>
                                            <td>{{ staff["rider.corporaterider.corporate.Name"] }}</td>
                                            <td>{{ moment(staff.TrxDate).subtract(3,'hours').format("HH:mm MMM Do YY")}}</td>
                                            <td>{{ staff["StaffTask.RecommendedTime"]}}</td>
                                            <td>{{`${humanizeDuration(moment.duration(Math.abs(timediff(staff)), 'minutes').asMilliseconds())} ${timediff(staff) > 0 ? "late 👿":"early 😇"}`}}</td>
                                            <td>{{ staff.Comments }}</td>
                                            <td>{{ staff.LocationName }}</td>
                                        </tr>
                                  
                                    </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>

<script>
import $ from 'jquery'
import 'datatables.net-dt'

import '../../node_modules/datatables.net-buttons/js/jquery.dataTables.min.js'
import '../../node_modules/datatables.net-buttons/js/dataTables.buttons.js'
import '../../node_modules/datatables.net-buttons/js/jszip.min.js'
import '../../node_modules/datatables.net-buttons/js/pdfmake.min.js'
import '../../node_modules/datatables.net-buttons/js/vfs_fonts.js'
import '../../node_modules/datatables.net-buttons/js/buttons.html5.min.js'
import '../../node_modules/datatables.net-bs4/js/dataTables.bootstrap4.js'

// import '../../node_modules/datatables.net-buttons-dt/css/buttons.dataTables.css'
// import '../../node_modules/datatables.net-bs4/css/dataTables.bootstrap4.css'




import moment from "moment"
import _ from "lodash"
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from './DataLoading'
import humanizeDuration  from 'humanize-duration'
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";

export default {
    components: { 
       flatPicker,
       Loading,
       LottieAnimation
    },
    data(){
        return{
      
            form: {
                range: `${moment().subtract("1","days").format("YYYY-MM-DD")} to ${moment().format("YYYY-MM-DD")} `,
                mobile:'',
                task:''
            },
            attendance:_.groupBy(this.$store.state.attendance, 'rider.MobileNumber'),
            timestamp:moment().format(),
            report:this.$store.state.report,
            loading:false,    
            tasks:this.$store.state.tasks,
            depts:this.$store.state.departments
            
            
        }
    },
    mounted(){
        
        this.getReport()
        
    },
    computed:{
        moment(){
              return moment
        },
          humanizeDuration(){
              return humanizeDuration
        },
        
        
    },
    methods:{
        getNow(){
            this.timestamp = moment().format();
        },
        timediff(staff){
            return moment(staff.TrxDate).subtract(3,'hours').diff(moment(`${moment(staff.TrxDate).startOf('day').format('YYYY-MM-DD')} ${staff["StaffTask.RecommendedTime"]}`), 'minutes')
        },
        getReport(){
            this.loading = true                
                
            this.$store.dispatch("getReport",{ dept :this.form.dept, mobile:this.form.mobile ,task:this.form.task , fromdate:this.form.range.split("to")[0] , todate:this.form.range.split("to")[1] ? this.form.range.split("to")[1] : this.form.range.split("to")[0] })
            .then(()=>{
                this.report = this.$store.state.report

                $('#myTable').DataTable().destroy();
                this.$nextTick().then(()=>$('#myTable').DataTable({
                        dom: 'Bfrtip',
                        buttons: [
                            'copyHtml5',
                            'excelHtml5',
                            'csvHtml5',
                            'pdfHtml5'
                        ]
                    }))
                                  
                 this.loading = false
                
                
            })
        }
     
        
    }
};
</script>

<style>

</style>
